/*eslint-disable*/export const messages=JSON.parse("{\"icon.title.search\":[\"Forstørrelsesglas\"]}");